import { applyCardViewChangesToGrid } from "../../helper/row-sync-card-grid/applyCardViewChangesToGrid";
import ACTION_TYPES from "../xTablesReduxActionTypes";

// reducer.js
const generateSessionId = () => `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;

const INITIAL_STATE = {
	gridInitializationTime: new Date().toUTCString(),
	loggedInUser: '',
	allxSpacesUsers: [],
	selectedCellReduxState: "",
	predecessorcolumn: {},
	statusColumnRollupInfo: "",
	highlight: false,
	activeFilters: {},
	color: '#73FF00',
	TimeRange: 'lastHour',
	gridChangesPerSaveSession: { add: {}, update: {}, delete: {}, addedRowsBelowNodeMap: {} },
	saveButtonDisabled: true,
	cardView: false,
	isUpdating: false,
	isFilterOrSummaryViewActive: false,
	isViewChanging: false,
	columnSyncTimestamps: {},
	sessionId: generateSessionId(),
	statusColumns: {},
	operationInProgress : false,
	gridRowsForCardSync:[],
	rowIdToIndexMap: {}
}

// Rows can become corrupted

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ACTION_TYPES.SET_USER:
			return {
				...state,
				loggedInUser: action.loggedInUser,
			}
		case ACTION_TYPES.SET_ALLUSERS:
			return {
				...state,
				allxSpacesUsers: action?.allxSpacesUsers || state.allxSpacesUsers,
			}
		case ACTION_TYPES.SET_SELECTEDCELL_STATE:
			return {
				...state,
				selectedCellReduxState: action.selectedCellReduxState
			}
		case ACTION_TYPES.SET_PREDECESSORCOLUMN_STATE:
			return {
				...state,
				predecessorcolumn: action.predecessorcolumn
			}
		case ACTION_TYPES.SET_STATUSCOLUMN_STATE:
			return {
				...state,
				statusColumnRollupInfo: action.statusColumnRollupInfo
			}

		case ACTION_TYPES.SET_HIGHLIGHTING:
			return {
				...state,
				highlight: action.highlight,
				color: action.color,
				timeRange: action.timeRange,
				customDate: action.customDate,
			}
		case ACTION_TYPES.SET_GRIDCHANGESPERSESSION:
			return {
				...state,
				gridChangesPerSaveSession: action.gridChangesPerSaveSession,
			}
		case ACTION_TYPES.SET_UPDATEROWS: {
			const rows = action.gridRowsForCardSync || [];
			const recalulateRowIdToIndexMap =
				action.recalulateRowIdToIndexMap === true;
			let rowIdToIndexMap = state.rowIdToIndexMap || {};

			if (recalulateRowIdToIndexMap) {
				rowIdToIndexMap = {};

				rows.forEach(function (row, index) {
					if (row && row.id) {
						rowIdToIndexMap[row.id] = index + 1;
					}
				});
			}

			return {
				...state,
				gridRowsForCardSync: rows,
				rowIdToIndexMap,
			};
		}

		case ACTION_TYPES.ENABLE_SAVE_BUTTON:
			return {
				...state,
				saveButtonDisabled: false
			}
		case ACTION_TYPES.DISABLE_SAVE_BUTTON:
			return {
				...state,
				saveButtonDisabled: true
			}
		case ACTION_TYPES.SET_FILTER_MODEL:
			return {
				...state,
				activeFilters: action.activeFilters,
			};

		case ACTION_TYPES.CLEAR_FILTER_MODEL:
			return {
				...state,
				activeFilters: [],
			};
		case ACTION_TYPES.SET_CLONE_DATA_OF_ROWS:
			return {
				...state,
				cloneRowsData: action.cloneRowsData,
			};
		case ACTION_TYPES.ENABLE_CARD_VIEW:
			return {
				...state,
				cardView: action.cardView
			}
		case ACTION_TYPES.IS_FILTER_OR_SUMMARY_VIEW_ACTIVE:
			return {
				...state,
				isFilterOrSummaryViewActive: action.isFilterOrSummaryViewActive
			}
		case ACTION_TYPES.SET_IS_UPDATING:
			return {
				...state,
				isUpdating: action.isUpdating
			}
		case ACTION_TYPES.SET_VIEW_CHANGING:
			return {
				...state,
				isViewChanging: action.payload,
			};
		case ACTION_TYPES.SET_LAST_SYNCED_TIMESTAMP: {
			const { colId, timestamp } = action.payload;
			return {
				...state,
				columnSyncTimestamps: {
					...state.columnSyncTimestamps,
					[colId]: timestamp
				}
			};
		}
		case ACTION_TYPES.SET_SESSIONID:
			return {
				...state,
				sessionId: action.sessionId,
			};
		case ACTION_TYPES.SET_STATUS_COLS:
			const { colId, statusColumns } = action.payload;
			return {
				...state,
				statusColumns: {
					...state.statusColumns,
					[colId]: statusColumns
				}
			};
		case ACTION_TYPES.DELETE_STATUS_COL:
			const updated = { ...state.statusColumns };
			delete updated[action.payload.colId];
			return {
				...state,
				statusColumns: updated,
			};
		case ACTION_TYPES.RESET_STATUS_COLS:
			return {
				...state,
				statusColumns: {},
			};
		case ACTION_TYPES.SET_OPERATIONINPROGRESS:
			return {
				...state,
				operationInProgress: action.operationInProgress,
			};

			case ACTION_TYPES.SAVE_CARD_VIEW_CHANGES: {
				const {
				  deletedCardIds,
				  insertedCards,
				updatedCards,
				rows,dependencyMap,
				headerNameToColObjForCard
			} = action.payload;
			console.log("deletedCardIds insertedCardsupdatedCards rowsForSaving",
				deletedCardIds,
				insertedCards,
				updatedCards,
				rows,dependencyMap)

				const result = applyCardViewChangesToGrid(
				  rows,
				  dependencyMap,
				  headerNameToColObjForCard,
				  state.loggedInUser,
				  {
					deletedCardIds,
					insertedCards,
					updatedCards,
				  },
				  {
					predecessorColumn: state.predecessorcolumn,
				  }
				);
			  
				/* ---------------------------------------------
				 * Build gridChangesPerSaveSession
				 * --------------------------------------------- */
				const newGridChanges = {
				  add: { ...state.gridChangesPerSaveSession.add },
				  update: { ...state.gridChangesPerSaveSession.update },
				  delete: { ...state.gridChangesPerSaveSession.delete },
				  addedRowsBelowNodeMap: {
					...state.gridChangesPerSaveSession.addedRowsBelowNodeMap,
				  },
				};
			  
				// DELETE
				result.deletedRows.forEach((row) => {
				  newGridChanges.delete[row.id] = row;
			  
				  // safety: remove from add/update if present
				  delete newGridChanges.add[row.id];
				  delete newGridChanges.update[row.id];
				});
			  
				// INSERT
				result.insertedRows.forEach((row) => {
				  newGridChanges.add[row.id] = row;
				});
			  
				// UPDATE
				result.updatedRows.forEach((row) => {
				  newGridChanges.update[row.id] = {
					...(newGridChanges.update[row.id] || {}),
					...row,
				  };
				});
			  
				return {
				  ...state,
				  gridRowsForCardSync: result.rows,
				  gridChangesPerSaveSession: newGridChanges,
				  saveButtonDisabled: false,
				  cardView: false,
				};
			  }
			  


		default:
			return state;
	}
};